export default {
  emailListPlaceholder: {
    id: 'FORMS_EMAIL_LIST_CONTROLS_PLACEHOLDER',
    defaultMessage: 'Add emails separated by commas',
    description: 'placeholder for the email list control entries',
  },
};
